import { useSelector } from 'react-redux';

import { selectBuildingCard } from 'shared/selectors/buildingCard';
import {
  type IRepresentativeRequestData,
  createRepresentativeRequest,
} from 'shared/services/createRepresentativeRequest';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { BuildingContacts } from './BuildingContacts';
import { RepresentativeCard } from './components/RepresentativeCard';
import { RepresentativeRequest } from './components/RepresentativeRequest';

export const BuildingContactsContainer = () => {
  const { id, representative } = useSelector(selectBuildingCard);
  const { logger } = useApplicationContext();

  const handleRequestSubmit = (data: IRepresentativeRequestData) =>
    createRepresentativeRequest({ logger, buildingId: id, ...data });

  return (
    <BuildingContacts>
      {representative ? (
        <RepresentativeCard representative={representative} />
      ) : (
        <RepresentativeRequest onSubmit={handleRequestSubmit} />
      )}
    </BuildingContacts>
  );
};
